module.exports = __webpack_public_path__ + "static/img/broken_link.d1d3f87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/broken_link.png
// module id = tw8r
// module chunks = 16